let listeners: (() => void)[] = [];

export const subscribeNotifications = (cb: () => void) => {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
};

export const notifyNotificationsUpdate = () => {
  listeners.forEach((l) => l());
};